import queryString from 'query-string';
import http from '../httpConfig';
import { List, AddEditApi, ChangePasswordApi } from '../interfaces/user.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: List) => {
  const { searchText, role, status, ...others } = payload;
  const paging = buildPagingResponse(others);
  const queryParams: any = {
    ...paging,
    search: searchText,
    role,
    status,
  };

  // Note: Backend schema currently only supports search, page, pageSize, sortBy, sortOrder.
  // Role and status filters might be stripped by backend validation if not added to schema.

  const url = `${API_ENDPOINTS.listUsers}?${queryString.stringify(queryParams)}`;
  return http.get(url);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.addUser, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.editUser}/${id}`, payload);
};

const changePassword = (payload: ChangePasswordApi) => {
  return http.post(API_ENDPOINTS.changePassword, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getUser}/${id}`);
};

const kpis = () => {
  // Mock data - Keep as is for now if backend KPI not ready
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        records:
        {
          total_users: 24,
          active_users: 20,
          logged_in_users: 0,
          inactive_users: 4,
          users_with_manager: 17,
          manager_users: 8,
        },
      });
    }, 500);
  });

  // return http.get(API_ENDPOINTS.userListKpis);
};

const lookup = (payload: {
  searchText: string;
  exclude?: string;
  exclude_id?: string;
  is_active?: string;
  role?: string;
}) => {
  const url = `${API_ENDPOINTS.lookupUsers}?${queryString.stringify({ search: payload.searchText || '', exclude: payload.exclude, exclude_id: payload.exclude_id, is_active: payload.is_active, role: payload.role })}`;
  return http.get(url);
};

const UserService = {
  list,
  add,
  edit,
  changePassword,
  get,
  kpis,
  lookup,
};

export default UserService;
